// extracted by mini-css-extract-plugin
export default {"container":"styles_container__jZ-D4","row":"styles_row__yiyLh","link":"styles_link__RBawr","atomName":"styles_atomName__bHC35"};